export const navigation = {
  philosophy: "Философия",
  services: "Услуги",
  training: "Обучение",
  credentials: "Квалификация",
  clientele: "Клиентура",
  approach: "Подход",
  contact: "Контакты"
};

export const hero = {
  title: "Элитная Медицинская Безопасность",
  subtitle: "Для Состоятельных Клиентов",
  description: "Предоставление непревзойденного обучения неотложной медицинской помощи и служб реагирования для ультра-состоятельных семей, частных поместий, роскошных яхт и эксклюзивных корпоративных сред по всему миру.",
  cta: "Записаться на Консультацию"
};

export const philosophy = {
  title: "Наша Философия",
  subtitle: "Совершенство Без Компромиссов",
  description: "Мы верим, что медицинские чрезвычайные ситуации требуют немедленного экспертного вмешательства. Наша философия сосредоточена на предоставлении высшего уровня медицинского обучения и служб экстренного реагирования, специально разработанных для взыскательных клиентов, которые требуют только лучшего."
};

export const services = {
  title: "Основные Услуги",
  subtitle: "Комплексные Медицинские Решения",
  cpr_title: "Продвинутое Обучение СЛР/АВД",
  cpr_description: "Профессиональные сертификационные курсы, разработанные для домашнего персонала, экипажей яхт и охранного персонала.",
  emergency_title: "Экстренное Реагирование",
  emergency_description: "Круглосуточные службы быстрого медицинского реагирования с элитными командами парамедиков.",
  consultation_title: "Медицинская Консультация",
  consultation_description: "Экспертные медицинские консультационные услуги для высокорисковых сред и деятельности."
};

export const footer = {
  copyright: "© 2024 U First Doctors. Все права защищены.",
  phone: "Телефон",
  email: "Электронная почта",
  address: "Адрес"
};